import store from '../store'
// 引入qs模块处理，指定传递的参数数据格式为Form Data
import qs from 'qs'
// 引入ajax插件axios
import axios from 'axios'
import objectAssign from 'object-assign'
require('es6-promise').polyfill()
// 让ajax携带cookie
// axios.defaults.withCredentials = true
// 设置请求头
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded; charset=UTF-8'
// 设置请求超时时间
axios.defaults.timeout = 10000
// `validateStatus` 定义对于给定的HTTP 响应状态码是 resolve 或 reject  promise 。如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，promise 将被 resolve; 否则，promise 将被 rejecte
axios.defaults.validateStatus = status => {
  return status
}
let cancel
let promiseArr = {}
const CancelToken = axios.CancelToken

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 发起请求时，取消掉当前正在进行的相同请求
    if (promiseArr[config.url]) {
      promiseArr[config.url]('操作取消')
      promiseArr[config.url] = cancel
    } else {
      promiseArr[config.url] = cancel
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export default {
  // 必选参数url，可选参数params，callback
  get(obj) {
    const defaults = {
      isLoading: true,
      url: '#',
      data: {},
      success: res => {},
      error: err => {}
    }
    objectAssign(defaults, obj)
    if (defaults.isLoading) {
      store.commit('updateLoadingStatus', {
        isLoading: true
      })
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: defaults.url,
        params: defaults.data,
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      })
        .then(res => {
          if (defaults.isLoading) {
            setTimeout(() => {
              store.commit('updateLoadingStatus', {
                isLoading: false
              })
            }, 200)
          }
          resolve(res)
          if (defaults.success && typeof defaults.success === 'function') {
            defaults.success(res)
          }
        })
        .catch(err => {
          if (defaults.isLoading) {
            setTimeout(() => {
              store.commit('updateLoadingStatus', {
                isLoading: false
              })
            }, 200)
          }
          reject(err)
          if (defaults.error && typeof defaults.error === 'function') {
            defaults.error(err)
          }
        })
    })
  },
  post(obj) {
    const defaults = {
      isLoading: true,
      url: '#',
      data: {},
      success: res => {},
      error: err => {}
    }
    objectAssign(defaults, obj)
    if (defaults.isLoading) {
      store.commit('updateLoadingStatus', {
        isLoading: true
      })
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: defaults.url,
        data: qs.stringify(defaults.data),
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      })
        .then(res => {
          if (defaults.isLoading) {
            setTimeout(() => {
              store.commit('updateLoadingStatus', {
                isLoading: false
              })
            }, 200)
          }
          resolve(res)
          if (defaults.success && typeof defaults.success === 'function') {
            defaults.success(res)
          }
        })
        .catch(err => {
          if (defaults.isLoading) {
            setTimeout(() => {
              store.commit('updateLoadingStatus', {
                isLoading: false
              })
            }, 200)
          }
          reject(err)

          if (defaults.error && typeof defaults.error === 'function') {
            defaults.error(err)
          }
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/ajax.js